import React from 'react'
import ContactHero from './Contact/ContactHero'
import ContactInformation from './Contact/ContactInformation'
import Footer from './Footer'


export default function ContactUs() {
  return (
    <div>
      <ContactHero />
      <ContactInformation />
      <Footer></Footer>
    </div>
  )
}
